import { IconCheck } from "@tabler/icons-react";
import Text from "./Text";
import { STEP_BADGE_COLORS, type StepStatus } from "./stepStatus";
import styles from "./StepBadge.module.css";

interface StepBadgeProps {
  status: StepStatus;
  number: number;
}

/** Pastille ronde d'une étape : numéro, ou coche une fois l'étape terminée. */
export default function StepBadge({ status, number }: StepBadgeProps) {
  return (
    <Text
      as="div"
      className={styles.badge}
      color={STEP_BADGE_COLORS[status]}
      background
    >
      {status === "done" ? <IconCheck size={16} stroke={3} /> : number}
    </Text>
  );
}
